export const enum TabValue {
  Overview = 'SubjectDetails/Overview',
  Assignments = 'SubjectDetails/Assignments',
  Resources = 'SubjectDetails/Resources',
  Syllabus = 'SubjectDetails/Syllabus',
}
